export default __webpack_public_path__ + "static/media/Room_not_found.4ae459b7.png";